webpackJsonp([36733297554888],{

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BlogListItem = __webpack_require__(389);
	
	var _BlogListItem2 = _interopRequireDefault(_BlogListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPosts = function (_React$Component) {
	  _inherits(BlogPosts, _React$Component);
	
	  function BlogPosts(props) {
	    _classCallCheck(this, BlogPosts);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.posts = _this.props.posts;
	    return _this;
	  }
	
	  BlogPosts.prototype.render = function render() {
	    return _react2.default.createElement(
	      'section',
	      { className: 'blog-list' },
	      this.posts.map(function (post) {
	        if (post.node.categories[0].name === 'Blog') {
	          return _react2.default.createElement(_BlogListItem2.default, { key: post.node.slug, article: post.node });
	        }
	      })
	    );
	  };
	
	  return BlogPosts;
	}(_react2.default.Component);
	
	exports.default = BlogPosts;
	module.exports = exports['default'];

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlogListItem = function BlogListItem(_ref) {
	  var article = _ref.article;
	  return _react2.default.createElement(
	    'article',
	    { className: 'blog-list__item', style: { marginBottom: 50 } },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: '/blog/' + article.slug },
	      _react2.default.createElement(
	        'div',
	        {
	          className: 'preview-image',
	          style: {
	            backgroundImage: 'url(' + article.featured_media.localFile.childImageSharp.resolutions.src
	          },
	          title: article.title,
	          alt: article.featured_media.localFile.childImageSharp.resolutions.src
	        },
	        _react2.default.createElement(
	          'time',
	          null,
	          _react2.default.createElement(
	            'i',
	            { className: 'material-icons' },
	            'date_range'
	          ),
	          article.date
	        ),
	        _react2.default.createElement(
	          'h3',
	          null,
	          article.title
	        ),
	        _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: article.excerpt } })
	      )
	    )
	  );
	};
	
	exports.default = BlogListItem;
	module.exports = exports['default'];

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(45);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Paginator = function Paginator(_ref) {
	  var pathContext = _ref.pathContext;
	
	  var index = pathContext.index,
	      first = pathContext.first,
	      last = pathContext.last,
	      pageCount = pathContext.pageCount,
	      previousUrl = function previousUrl() {
	    var indexPos = function indexPos(num) {
	      return num === 1 ? '' : num.toString();
	    };
	
	    if (index === 1) {
	      return "";
	    } else if (index > 1) {
	      return indexPos(index - 1);
	    }
	  },
	      nextUrl = function nextUrl() {
	    if (index === pageCount) {
	      return '';
	    } else {
	      return (index + 1).toString();
	    }
	  },
	      pagesLinks = function pagesLinks() {
	    var links = [],
	        setLink = function setLink(i) {
	      if (i === index) {
	        links.push(_react2.default.createElement(
	          'span',
	          { key: i, className: 'paginator__page paginator__page--active' },
	          i
	        ));
	      } else if (i === 1) {
	        links.push(_react2.default.createElement(
	          _gatsbyLink2.default,
	          { key: i, className: 'paginator__page', to: '/blog/' },
	          i
	        ));
	      } else {
	        links.push(_react2.default.createElement(
	          _gatsbyLink2.default,
	          { key: i, className: 'paginator__page', to: '/blog/' + i },
	          i
	        ));
	      }
	    };
	
	    for (var i = 0; i <= pageCount; i += 1) {
	      if (i > 0) {
	        setLink(i);
	      }
	    }
	    return links.map(function (link) {
	      return link;
	    });
	  };
	
	  console.log(pathContext);
	  return _react2.default.createElement(
	    'section',
	    { className: 'paginator' },
	    first ? _react2.default.createElement(
	      'span',
	      { className: 'paginator__prev paginator__prev--not-active' },
	      _react2.default.createElement(
	        'i',
	        { className: 'material-icons' },
	        'keyboard_arrow_left'
	      )
	    ) : _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'paginator__prev', to: '/blog/' + previousUrl() },
	      _react2.default.createElement(
	        'i',
	        { className: 'material-icons' },
	        'keyboard_arrow_left'
	      )
	    ),
	    pagesLinks(),
	    last ? _react2.default.createElement(
	      'span',
	      { className: 'paginator__next paginator__next--not-active' },
	      _react2.default.createElement(
	        'i',
	        { className: 'material-icons' },
	        'keyboard_arrow_right'
	      )
	    ) : _react2.default.createElement(
	      _gatsbyLink2.default,
	      { className: 'paginator__next', to: '/blog/' + nextUrl() },
	      _react2.default.createElement(
	        'i',
	        { className: 'material-icons' },
	        'keyboard_arrow_right'
	      )
	    )
	  );
	};
	
	exports.default = Paginator;
	module.exports = exports['default'];

/***/ }),

/***/ 409:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.blogMetaQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(80);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _FlyContainer = __webpack_require__(55);
	
	var _FlyContainer2 = _interopRequireDefault(_FlyContainer);
	
	var _TitleImage = __webpack_require__(56);
	
	var _TitleImage2 = _interopRequireDefault(_TitleImage);
	
	var _BlogList = __webpack_require__(388);
	
	var _BlogList2 = _interopRequireDefault(_BlogList);
	
	var _Paginator = __webpack_require__(390);
	
	var _Paginator2 = _interopRequireDefault(_Paginator);
	
	var _favicon = __webpack_require__(93);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var blogMetaQuery = exports.blogMetaQuery = '** extracted graphql fragment **';
	
	var BlogTemplate = function (_Component) {
	  _inherits(BlogTemplate, _Component);
	
	  function BlogTemplate() {
	    _classCallCheck(this, BlogTemplate);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this));
	
	    _this.posts = '';
	    _this.metaData = '';
	    return _this;
	  }
	
	  BlogTemplate.prototype.componentWillMount = function componentWillMount() {
	    this.posts = this.props.pathContext.group;
	    this.metaData = this.props.data.site.siteMetadata;
	  };
	
	  BlogTemplate.prototype.render = function render() {
	    return _react2.default.createElement(
	      _FlyContainer2.default,
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: this.metaData.blog.title,
	        meta: [{ name: 'description', content: this.metaData.blog.description }, { name: 'keywords', content: this.metaData.keywords }, { name: 'theme-color', content: '#881F62' }, { name: 'background', content: '#881F62' }, { name: 'lang', content: 'ru' }],
	        link: [{ rel: 'shortcut icon', type: 'image/png', href: '' + _favicon2.default }]
	      }),
	      _react2.default.createElement(_TitleImage2.default, { type: 'blog' }),
	      _react2.default.createElement(
	        'h1',
	        { className: 'main-header' },
	        '\u0411\u043B\u043E\u0433'
	      ),
	      _react2.default.createElement(_BlogList2.default, { posts: this.posts }),
	      _react2.default.createElement(_Paginator2.default, { pathContext: this.props.pathContext })
	    );
	  };
	
	  return BlogTemplate;
	}(_react.Component);
	
	BlogTemplate.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  edges: _propTypes2.default.array
	};
	
	exports.default = BlogTemplate;

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-js-cc606016620959217226.js